// extracted by mini-css-extract-plugin
export default {"empty":"EmptyState_empty__naVmd"};